import { isFetchResultSuccessful } from '@/entities/FetchResult'
import { LeaveOfAbsenceForm } from '@/entities/LeaveOfAbsences/LeaveOfAbsences'
import {
    createLeaveOfAbsenceApiCall,
    getLeaveOfAbsencesApiCall,
} from '@/entities/LeaveOfAbsences/LeaveOfAbsencesService'
import {
    NotificationCenterAction,
    NotificationCenterActionCategory,
    NotificationCenterCategory,
} from '@/entities/NotificationCenter/NotificationCenter'
import {
    endEventLoggerApiCall,
    startEventLoggerApiCall,
} from '@/entities/NotificationCenter/NotificationCenterService'
import { trans } from '@/helpers/trans'
import {
    setIsSuccessful as leaveOfAbsenceIsDeletedSuccessful,
} from '@/redux/leaveOfAbsenceRequestDetail/leaveOfAbsenceRequestDetailReducer'
import { TypedDispatch } from '@/redux/store'
import { setToast } from '@/redux/toasts/toastsReducer'
import { ToastType } from '@/types'

import { setError, setIsLoading, setIsSuccessful, setLeaveOfAbsencesRequest } from './leaveOfAbsencesRequestsReducer'

export const getLeaveOfAbsences = (year: number) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))

    try {
        const response = await getLeaveOfAbsencesApiCall(year)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setIsLoading(false))

            return
        }

        dispatch(setLeaveOfAbsencesRequest(response.data))
        dispatch(leaveOfAbsenceIsDeletedSuccessful(false))
        dispatch(setIsSuccessful(false))
    } catch (error) {
        console.error('[getLeaveOfAbsences]', error)

        dispatch(setError('Error fetching data'))
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const addLeaveOfAbsence = (leaveOfAbsence: LeaveOfAbsenceForm) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsSuccessful(false))

    const responseTracker = await startEventLoggerApiCall(
        NotificationCenterCategory.LEAVE_OF_ABSENCE,
        NotificationCenterAction.CREATED,
        [NotificationCenterActionCategory.SOURCE_EMPLOYEE_APP],
    )

    if (! isFetchResultSuccessful(responseTracker)) {
        dispatch(setError(responseTracker.error))
        return
    }

    try {
        const response = await createLeaveOfAbsenceApiCall(leaveOfAbsence, responseTracker.data)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setIsLoading(false))

            return
        }

        dispatch(setToast({
            text: trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceRequest'),
            type: ToastType.pass,
        }))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[addLeaveOfAbsence]', error)

        dispatch(setError('Error fetching data'))
    } finally {
        await endEventLoggerApiCall(responseTracker.data)
        dispatch(setIsLoading(false))
    }
}
